var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.normalizedValue,"dense":_vm.dense,"hide-details":_vm.hideDetails,"items":_vm.items,"label":_vm.label,"menu-props":{ offsetY: true },"rules":_vm.rules,"item-text":"text","item-value":"value","outlined":""},on:{"input":v => _vm.$emit('input', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }